var _circle, _circle2, _g, _g2, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _g3, _path18, _g4, _g5, _g6, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _g7, _g8, _path29, _path30, _path31, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg09IntroOnboard02(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 305,
    height: 436,
    viewBox: "0 0 305 436",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 153,
    cy: 285,
    r: 151,
    fill: "#F39F51"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3141_12046",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 134,
    width: 302,
    height: 302
  }, _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 153,
    cy: 285,
    r: 151,
    fill: "#151515"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3141_12046)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M236.436 201.95C236.436 201.95 151.166 313.71 124.916 319.14C124.496 319.23 124.076 319.31 123.666 319.38C104.656 322.59 86.286 291.38 109.276 275.6C117.526 269.93 124.206 267.19 138.596 255.35L218.186 190.89L236.436 201.95Z",
    fill: "#6D34E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.436 201.95C236.436 201.95 151.166 313.71 124.916 319.14C124.496 319.23 124.076 319.31 123.666 319.38C104.656 322.59 86.286 291.38 109.276 275.6C117.526 269.93 124.206 267.19 138.596 255.35L218.186 190.89L236.436 201.95Z",
    fill: "url(#paint0_linear_3141_12046)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.436 201.95L218.186 190.89L138.596 255.35C124.206 267.19 117.526 269.93 109.276 275.6",
    stroke: "#111111"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.656 234.59C69.656 234.59 58.176 259.15 61.796 269.97L83.066 242.1L73.656 234.17L69.656 234.6V234.59Z",
    fill: "#F0EFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.876 381.93C23.876 381.93 15.686 307.39 82.886 277.14C99.186 270.05 119.806 276.61 127.496 283.11C143.436 296.58 152.346 309.09 163.076 371.49C173.806 433.89 167.876 455.63 167.876 455.63C167.876 455.63 47.366 459.65 23.876 381.94V381.93Z",
    fill: "#6D34E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.876 381.93V381.94C47.366 459.65 167.876 455.63 167.876 455.63C167.876 455.63 173.806 433.89 163.076 371.49C152.346 309.09 143.436 296.58 127.496 283.11C120.879 277.517 104.688 271.879 89.9133 274.932",
    stroke: "#111111",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.866 381.93C292.866 381.93 301.056 307.39 233.856 277.14C217.556 270.05 196.936 276.61 189.246 283.11C173.306 296.58 164.396 309.09 153.666 371.49C142.936 433.89 148.866 455.63 148.866 455.63C148.866 455.63 269.376 459.65 292.866 381.94V381.93Z",
    fill: "#9475D7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.866 381.93C292.866 381.93 301.056 307.39 233.856 277.14C217.556 270.05 196.936 276.61 189.246 283.11C173.306 296.58 164.396 309.09 153.666 371.49C142.936 433.89 148.866 455.63 148.866 455.63C148.866 455.63 269.376 459.65 292.866 381.94V381.93Z",
    fill: "url(#paint1_linear_3141_12046)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.856 277.14C217.556 270.05 196.936 276.61 189.246 283.11C173.306 296.58 164.396 309.09 153.666 371.49C142.936 433.89 148.866 455.63 148.866 455.63",
    stroke: "#111111",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.666 234.17C73.666 234.17 60.046 254.78 61.806 269.98C63.536 276.86 78.296 265.25 88.066 264.66C97.836 264.07 105.716 266.55 108.946 263.81C112.176 261.07 143.086 233.97 133.746 188.23L73.656 234.16L73.666 234.17Z",
    fill: "#423D52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.666 234.17C73.666 234.17 60.046 254.78 61.806 269.98C63.536 276.86 78.296 265.25 88.066 264.66C97.836 264.07 105.716 266.55 108.946 263.81C112.176 261.07 143.086 233.97 133.746 188.23L73.656 234.16L73.666 234.17Z",
    fill: "url(#paint2_linear_3141_12046)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.696 255.22V277.62C93.696 277.62 102.636 284.3 114.776 278.33V255.22H93.696Z",
    fill: "#CB6C66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.236 220.06C147.687 220.06 152.106 215.641 152.106 210.19C152.106 204.739 147.687 200.32 142.236 200.32C136.785 200.32 132.366 204.739 132.366 210.19C132.366 215.641 136.785 220.06 142.236 220.06Z",
    fill: "#CABDFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.316 232.19C144.141 232.19 152.106 224.225 152.106 214.4C152.106 204.575 144.141 196.61 134.316 196.61C124.491 196.61 116.526 204.575 116.526 214.4C116.526 224.225 124.491 232.19 134.316 232.19Z",
    fill: "#9790AA"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_3141_12046)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M150.263 208.633C148.989 204.845 144.758 201.005 142.786 199.687L145.626 202.69C148.36 204.766 148.494 207 148.989 208.372C150.128 210.042 150.612 217.363 150.496 220.39C150.812 218.903 151.887 213.463 150.263 208.633Z",
    fill: "#CFC6E8"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M149.082 219.217C149.271 213.343 144.715 206.204 142.831 204.016L141.937 205.099L145.286 210.682L147.113 219.411L146.504 228.174C147.181 227.565 148.892 225.091 149.082 219.217Z",
    fill: "#887FA3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.179 220.06C169.728 220.06 165.309 215.641 165.309 210.19C165.309 204.739 169.728 200.32 175.179 200.32C180.63 200.32 185.049 204.739 185.049 210.19C185.049 215.641 180.63 220.06 175.179 220.06Z",
    fill: "#CABDFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.099 232.19C173.274 232.19 165.309 224.225 165.309 214.4C165.309 204.575 173.274 196.61 183.099 196.61C192.924 196.61 200.889 204.575 200.889 214.4C200.889 224.225 192.924 232.19 183.099 232.19Z",
    fill: "#9790AA"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_3141_12046)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M167.153 208.633C168.426 204.845 172.657 201.005 174.63 199.687L171.789 202.69C169.055 204.766 168.922 207 168.426 208.372C167.287 210.042 166.804 217.363 166.92 220.39C166.603 218.903 165.529 213.463 167.153 208.633Z",
    fill: "#CFC6E8"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M168.333 219.217C168.144 213.343 172.701 206.204 174.584 204.016L175.479 205.099L172.129 210.682L170.302 219.411L170.911 228.174C170.234 227.565 168.523 225.091 168.333 219.217Z",
    fill: "#887FA3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.497 257.857C135.6 254.114 151.004 236.235 147.904 217.922C144.803 199.61 124.372 187.798 102.269 191.54C80.1663 195.283 64.7621 213.162 67.8628 231.475C70.9634 249.787 91.3947 261.599 113.497 257.857Z",
    fill: "#CB6C66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.516 218.81C65.516 218.81 70.456 185.98 99.356 182.78C99.356 182.78 123.046 178.92 135.756 191.56C138.366 194.81 138.846 196.6 139.416 201.74L137.376 199.68C137.376 199.68 119.826 185.84 100.906 192.43C94.306 194.83 84.136 197.98 76.516 215.56L65.516 218.82V218.81Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.4625 233.437C86.4625 233.437 80.7725 236.477 76.0325 238.297C73.7525 239.167 66.8325 241.577 66.8325 241.577C66.8325 241.577 55.6325 213.717 72.8525 195.457C82.7325 186.047 89.7425 182.847 102.392 181.717C116.052 181.107 128.002 182.937 137.572 196.307C141.792 201.927 143.672 210.467 143.672 210.467C143.672 210.467 141.282 211.647 138.922 212.707C137.382 213.397 132.242 214.757 132.242 214.757C132.242 214.757 130.302 206.967 127.572 205.147C127.352 205.027 127.592 206.467 127.592 206.467C127.592 206.467 128.202 211.527 128.342 216.077C128.342 216.077 120.622 220.487 112.482 223.937C105.002 227.107 92.4725 230.957 92.4725 230.957C92.4725 230.957 90.1525 224.227 86.7625 220.837C86.3725 220.497 87.8925 225.387 86.4625 233.447V233.437Z",
    fill: "#993F39"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.856 221.56L118.966 228.12C119.456 230.99 117.516 233.71 114.646 234.2C111.776 234.69 109.056 232.75 108.566 229.88L107.456 223.32",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.296 231.77C88.296 231.77 82.606 234.81 77.866 236.63C75.586 237.5 68.666 239.91 68.666 239.91C68.666 239.91 57.466 212.05 74.686 193.79C84.566 184.38 91.576 181.18 104.226 180.05C117.886 179.44 129.836 181.27 139.406 194.64C143.626 200.26 145.506 208.8 145.506 208.8C145.506 208.8 143.116 209.98 140.756 211.04C139.216 211.73 134.076 213.09 134.076 213.09C134.076 213.09 132.136 205.3 129.406 203.48C129.186 203.36 129.426 204.8 129.426 204.8C129.426 204.8 130.036 209.86 130.176 214.41C130.176 214.41 122.456 218.82 114.316 222.27C106.836 225.44 94.306 229.29 94.306 229.29C94.306 229.29 91.986 222.56 88.596 219.17C88.206 218.83 89.726 223.72 88.296 231.78V231.77Z",
    fill: "#272727"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.296 231.77C88.296 231.77 82.606 234.81 77.866 236.63C75.586 237.5 68.666 239.91 68.666 239.91C68.666 239.91 57.466 212.05 74.686 193.79C84.566 184.38 91.576 181.18 104.226 180.05C117.886 179.44 129.836 181.27 139.406 194.64C143.626 200.26 145.506 208.8 145.506 208.8C145.506 208.8 143.116 209.98 140.756 211.04C139.216 211.73 134.076 213.09 134.076 213.09C134.076 213.09 132.136 205.3 129.406 203.48C129.186 203.36 129.426 204.8 129.426 204.8C129.426 204.8 130.036 209.86 130.176 214.41C130.176 214.41 122.456 218.82 114.316 222.27C106.836 225.44 94.306 229.29 94.306 229.29C94.306 229.29 91.986 222.56 88.596 219.17C88.206 218.83 89.726 223.72 88.296 231.78V231.77Z",
    fill: "url(#paint3_linear_3141_12046)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.866 214.4L140.976 220.96C141.466 223.83 139.526 226.55 136.656 227.04C133.786 227.53 131.066 225.59 130.576 222.72L129.466 216.16",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.966 246.68C247.966 246.68 248.056 258.82 249.846 262.59C249.846 262.59 242.506 267.3 237.136 267.39C237.136 267.39 236.756 264 237.136 262.5C237.136 262.5 236.126 266.22 236.266 267.39C236.266 267.39 210.506 269.77 192.996 262.21C182.136 257.97 179.306 255.22 179.306 255.22C179.306 255.22 178.696 252.46 179.306 249.72C179.306 249.72 177.716 252.61 177.986 254.45C177.986 254.45 176.206 253.69 174.966 252.26C174.966 252.26 170.486 241.74 172.956 217.67L247.966 246.68Z",
    fill: "#272727"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.966 246.68C247.966 246.68 248.056 258.82 249.846 262.59C249.846 262.59 242.506 267.3 237.136 267.39C237.136 267.39 236.756 264 237.136 262.5C237.136 262.5 236.126 266.22 236.266 267.39C236.266 267.39 210.506 269.77 192.996 262.21C182.136 257.97 179.306 255.22 179.306 255.22C179.306 255.22 178.696 252.46 179.306 249.72C179.306 249.72 177.716 252.61 177.986 254.45C177.986 254.45 176.206 253.69 174.966 252.26C174.966 252.26 170.486 241.74 172.956 217.67L247.966 246.68Z",
    fill: "url(#paint4_linear_3141_12046)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.706 255.22V277.62C223.706 277.62 214.766 284.3 202.626 278.33V255.22H223.706Z",
    fill: "#CB6C66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.169 258.295C103.268 258.702 96.3553 257.676 93.7028 257.131L93.7028 265.808C98.2374 265.314 105.947 260.269 109.169 258.295Z",
    fill: "#993F39"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.1259 249.992C80.1259 249.992 87.4194 258.7 108.886 258.194",
    stroke: "#111111",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.954 231.759C252.055 213.446 236.65 195.567 214.548 191.825C192.445 188.083 172.014 199.894 168.913 218.207C165.813 236.52 181.217 254.399 203.319 258.141C225.422 261.883 245.853 250.072 248.954 231.759Z",
    fill: "#CB6C66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.263 258.383C214.164 258.79 221.076 257.765 223.729 257.22L223.729 265.897C219.194 265.403 211.485 260.358 208.263 258.383Z",
    fill: "#993F39"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.306 250.081C237.306 250.081 230.012 258.789 208.546 258.283",
    stroke: "#111111",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.886 218.81C251.886 218.81 246.946 185.98 218.046 182.78C218.046 182.78 194.356 178.92 181.646 191.56C179.036 194.81 178.556 196.6 177.986 201.74L180.026 199.68C180.026 199.68 197.576 185.84 216.496 192.43C223.096 194.83 233.266 197.98 240.886 215.56L251.886 218.82V218.81Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.546 214.4L176.436 220.96C175.946 223.83 177.886 226.55 180.756 227.04C183.626 227.53 186.346 225.59 186.836 222.72L187.946 216.16",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.116 183.77C48.006 206.88 67.966 238.59 67.966 238.59C82.976 229.96 98.656 218.52 111.106 208.78L108.926 205.31C108.926 205.31 102.686 195.92 112.846 188.57C116.526 186.01 124.046 184.72 128.346 189.56L131.146 192.37C133.776 190.12 135.256 188.8 135.256 188.8C121.326 172.34 95.826 175.72 83.116 183.77Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.326 197.64C116.146 200.27 112.486 203.09 108.936 205.34L111.116 208.81C114.976 205.79 118.526 202.93 121.646 200.37C125.566 197.15 128.816 194.41 131.156 192.4L128.356 189.59C128.356 189.59 124.486 193.36 119.326 197.64Z",
    fill: "#615C6C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.116 208.81L108.936 205.34C109.11 205.23 109.285 205.118 109.459 205.005L111.623 208.413C111.455 208.545 111.286 208.677 111.116 208.81Z",
    fill: "#494551"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.227 192.337L128.378 189.548C128.232 189.694 128.085 189.84 127.936 189.985L130.7 192.801C130.866 192.666 131.061 192.473 131.227 192.337Z",
    fill: "#494551"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.817 197.962L121.247 199.722C121.647 200.212 122.277 200.352 122.657 200.042L126.827 196.652C127.207 196.342 127.197 195.692 126.807 195.202L125.377 193.442C124.977 192.952 124.347 192.812 123.967 193.122L119.797 196.512C119.417 196.822 119.427 197.472 119.817 197.962ZM126.167 196.022L122.207 199.242C122.147 199.292 122.067 199.282 122.027 199.222L120.457 197.352C120.407 197.292 120.417 197.212 120.477 197.162L124.437 193.942C124.497 193.892 124.577 193.902 124.617 193.962L126.187 195.832C126.237 195.892 126.227 195.972 126.167 196.022Z",
    fill: "#2D2B33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.946 197.8L121.376 199.56C121.776 200.05 122.406 200.19 122.786 199.88L126.956 196.49C127.336 196.18 127.326 195.53 126.936 195.04L125.506 193.28C125.106 192.79 124.476 192.65 124.096 192.96L119.926 196.35C119.546 196.66 119.556 197.31 119.946 197.8ZM126.296 195.86L122.336 199.08C122.276 199.13 122.196 199.12 122.156 199.06L120.586 197.19C120.536 197.13 120.546 197.05 120.606 197L124.566 193.78C124.626 193.73 124.706 193.74 124.746 193.8L126.316 195.67C126.366 195.73 126.356 195.81 126.296 195.86Z",
    fill: "#F0EBFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.9634 255.598C87.2198 253.526 89.9904 248.065 88.1516 243.399C86.3129 238.734 80.5612 236.631 75.3048 238.703C70.0484 240.774 67.2779 246.236 69.1166 250.901C70.9553 255.567 76.707 257.669 81.9634 255.598Z",
    fill: "#A8A8A8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.146 242.39C75.146 242.39 73.466 243.66 72.576 245.7C71.956 247.1 71.706 248.87 72.626 250.82",
    stroke: "#6E6E6E",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.566 245.71C72.566 245.71 77.796 246.2 78.216 251.35",
    stroke: "#6E6E6E",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.264 247.515C249.103 242.85 246.333 237.388 241.076 235.317C235.82 233.245 230.068 235.348 228.229 240.013C226.391 244.679 229.161 250.14 234.418 252.212C239.674 254.283 245.426 252.181 247.264 247.515Z",
    fill: "#CB6C66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.016 221.5C201.286 222.67 202.986 223.37 205.086 224.26C212.566 227.43 225.096 231.28 225.096 231.28C225.096 231.28 227.416 224.55 230.806 221.16C231.196 220.82 229.676 225.71 231.106 233.77C231.106 233.77 236.796 236.81 241.536 238.63C243.816 239.5 248.535 239.872 248.535 239.872C248.535 239.872 259.131 212.431 241.911 194.171C232.031 184.761 227.826 183.18 215.176 182.05C201.516 181.44 190.006 181.77 179.996 196.64C175.776 202.26 173.896 210.8 173.896 210.8C173.896 210.8 176.216 212.15 178.646 213.04C182.586 214.48 185.326 215.09 185.326 215.09C185.326 215.09 187.266 207.3 189.996 205.48C190.086 205.29 189.736 207.06 189.736 207.06C189.736 207.06 189.256 211.97 189.116 216.52C189.116 216.52 189.756 217.04 192.216 218.35C193.276 218.91 194.896 219.68 196.116 219.96C196.116 219.96 196.886 211.98 198.446 208.12C198.446 208.12 198.366 214.11 198.496 215.96C198.636 218.01 199.026 221.51 199.026 221.51L199.016 221.5Z",
    fill: "#993F39"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.546 221.56L198.436 228.12C197.946 230.99 199.886 233.71 202.756 234.2C205.626 234.69 208.346 232.75 208.836 229.88L209.946 223.32",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.016 219.5C199.286 220.67 200.986 221.37 203.086 222.26C210.566 225.43 223.096 229.28 223.096 229.28C223.096 229.28 225.416 222.55 228.806 219.16C229.196 218.82 227.676 223.71 229.106 231.77C229.106 231.77 234.796 234.81 239.536 236.63C241.816 237.5 248.736 239.91 248.736 239.91C248.736 239.91 259.936 212.05 242.716 193.79C232.836 184.38 225.826 181.18 213.176 180.05C199.516 179.44 188.006 179.77 177.996 194.64C173.776 200.26 171.896 208.8 171.896 208.8C171.896 208.8 174.216 210.15 176.646 211.04C180.586 212.48 183.326 213.09 183.326 213.09C183.326 213.09 185.266 205.3 187.996 203.48C188.086 203.29 187.736 205.06 187.736 205.06C187.736 205.06 187.256 209.97 187.116 214.52C187.116 214.52 187.756 215.04 190.216 216.35C191.276 216.91 192.896 217.68 194.116 217.96C194.116 217.96 194.886 209.98 196.446 206.12C196.446 206.12 196.366 212.11 196.496 213.96C196.636 216.01 197.026 219.51 197.026 219.51L197.016 219.5Z",
    fill: "#272727"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.016 219.5C199.286 220.67 200.986 221.37 203.086 222.26C210.566 225.43 223.096 229.28 223.096 229.28C223.096 229.28 225.416 222.55 228.806 219.16C229.196 218.82 227.676 223.71 229.106 231.77C229.106 231.77 234.796 234.81 239.536 236.63C241.816 237.5 248.736 239.91 248.736 239.91C248.736 239.91 259.936 212.05 242.716 193.79C232.836 184.38 225.826 181.18 213.176 180.05C199.516 179.44 188.006 179.77 177.996 194.64C173.776 200.26 171.896 208.8 171.896 208.8C171.896 208.8 174.216 210.15 176.646 211.04C180.586 212.48 183.326 213.09 183.326 213.09C183.326 213.09 185.266 205.3 187.996 203.48C188.086 203.29 187.736 205.06 187.736 205.06C187.736 205.06 187.256 209.97 187.116 214.52C187.116 214.52 187.756 215.04 190.216 216.35C191.276 216.91 192.896 217.68 194.116 217.96C194.116 217.96 194.886 209.98 196.446 206.12C196.446 206.12 196.366 212.11 196.496 213.96C196.636 216.01 197.026 219.51 197.026 219.51L197.016 219.5Z",
    fill: "url(#paint5_linear_3141_12046)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.056 187.47C133.936 187.34 133.806 187.22 133.686 187.09C133.376 186.78 133.066 186.47 132.756 186.18C132.626 186.06 132.506 185.94 132.376 185.82C131.946 185.43 131.516 185.05 131.066 184.69C131.046 184.68 131.036 184.67 131.016 184.65C130.586 184.3 130.146 183.97 129.696 183.65C129.556 183.55 129.406 183.45 129.266 183.34C128.926 183.11 128.596 182.88 128.246 182.66C128.096 182.57 127.956 182.47 127.806 182.38C127.336 182.09 126.856 181.81 126.376 181.54C112.226 173.76 93.446 177.23 83.116 183.77C48.006 206.88 67.966 238.59 67.966 238.59C82.976 229.96 98.656 218.52 111.106 208.78L108.926 205.31C108.926 205.31 102.686 195.92 112.846 188.57C116.526 186.01 124.046 184.72 128.346 189.56L131.146 192.37C133.776 190.12 135.256 188.8 135.256 188.8C134.866 188.34 134.456 187.89 134.046 187.46L134.056 187.47Z",
    fill: "#F0EFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.056 187.47C133.936 187.34 133.806 187.22 133.686 187.09C133.376 186.78 133.066 186.47 132.756 186.18C132.626 186.06 132.506 185.94 132.376 185.82C131.946 185.43 131.516 185.05 131.066 184.69C131.046 184.68 131.036 184.67 131.016 184.65C130.586 184.3 130.146 183.97 129.696 183.65C129.556 183.55 129.406 183.45 129.266 183.34C128.926 183.11 128.596 182.88 128.246 182.66C128.096 182.57 127.956 182.47 127.806 182.38C127.336 182.09 126.856 181.81 126.376 181.54C112.226 173.76 93.446 177.23 83.116 183.77C48.006 206.88 67.966 238.59 67.966 238.59C82.976 229.96 98.656 218.52 111.106 208.78L108.926 205.31C108.926 205.31 102.686 195.92 112.846 188.57C116.526 186.01 124.046 184.72 128.346 189.56L131.146 192.37C133.776 190.12 135.256 188.8 135.256 188.8C134.866 188.34 134.456 187.89 134.046 187.46L134.056 187.47Z",
    fill: "url(#paint6_linear_3141_12046)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.1212 228.381C64.1212 228.381 59.0312 204.001 70.9912 189.261C82.9512 174.521 94.9324 172.621 106.751 172.621C106.751 172.621 131.261 171.571 140.861 197.031L138.411 193.641C138.411 193.641 137.941 192.791 136.341 190.961C132.921 187.031 126.341 178.371 110.421 177.491C105.421 177.211 99.2712 176.931 87.6912 185.111C77.9312 193.091 74.0012 204.761 75.0612 224.311L64.1312 228.371L64.1212 228.381Z",
    fill: "#9790AA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.1212 228.381C64.1212 228.381 59.0312 204.001 70.9912 189.261C82.9512 174.521 94.9324 172.621 106.751 172.621C106.751 172.621 131.261 171.571 140.861 197.031L138.411 193.641C138.411 193.641 137.941 192.791 136.341 190.961C132.921 187.031 126.341 178.371 110.421 177.491C105.421 177.211 99.2712 176.931 87.6912 185.111C77.9312 193.091 74.0012 204.761 75.0612 224.311L64.1312 228.371L64.1212 228.381Z",
    fill: "url(#paint7_linear_3141_12046)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.1212 228.381L75.0512 224.321C73.9912 204.771 77.9312 193.101 87.6812 185.121C93.4412 181.041 97.8612 179.071 101.471 178.151C94.2121 178.463 88.3921 179.786 83.0857 183.419C70.7099 190.795 65.1652 200.143 63.2212 211.371C62.5212 220.711 64.1212 228.381 64.1212 228.381Z",
    fill: "#9790AA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.0512 224.321L64.1212 228.381C64.1212 228.381 63.626 222.707 63.3557 220.525C66.9091 217.738 72.4492 217.657 74.7442 217.36C74.7702 218.592 74.9807 223.021 75.0512 224.321Z",
    fill: "url(#paint8_linear_3141_12046)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.4562 191.901C74.7821 202.859 74.5114 216.845 75.0196 223.028L72.7332 223.125C72.5427 212.452 74.2802 203.674 75.5484 200.731C78.1232 194.755 80.2492 189.233 87.4275 183.769C93.1702 179.399 100.155 178.227 101.227 178.227C90.6693 181.675 84.4404 187.319 81.4562 191.901Z",
    fill: "#78708F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.7463 257.381C85.8966 257.381 94.4336 251.709 94.8164 240.434C94.8164 230.609 87.5341 222.765 77.3838 222.765C67.2334 222.765 59.005 230.73 59.005 240.555C59.005 250.381 65.596 257.381 75.7463 257.381Z",
    fill: "#887FA3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.0012 258.311C85.8263 258.311 93.7912 250.346 93.7912 240.521C93.7912 230.696 85.8263 222.731 76.0012 222.731C66.176 222.731 58.2112 230.696 58.2112 240.521C58.2112 250.346 66.176 258.311 76.0012 258.311Z",
    fill: "#9790AA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.827 224.533C83.3502 224.605 81.8574 224.964 81.2929 226.929",
    stroke: "#78708F",
    strokeWidth: 0.4,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.3792 231.651C90.861 231.651 89.473 231.811 88.5188 233.827",
    stroke: "#78708F",
    strokeWidth: 0.4,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.3528 257.378C81.043 257.214 80.0635 256.866 79.9195 255.152",
    stroke: "#78708F",
    strokeWidth: 0.4,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.4274 232.811C81.1809 232.862 80.54 233.243 79.9484 234.353",
    stroke: "#78708F",
    strokeWidth: 0.4,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.0727 252.389C66.1 252.139 66.4166 251.464 67.4645 250.768",
    stroke: "#78708F",
    strokeWidth: 0.4,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.0803 230.615C66.1058 230.866 66.4175 231.543 67.4603 232.247",
    stroke: "#78708F",
    strokeWidth: 0.4,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.848 225.117C84.4647 225.002 83.1517 225.227 82.6933 226.529",
    stroke: "#78708F",
    strokeWidth: 0.4,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.7556 232.353C91.4981 232.387 90.6922 232.353 90.2107 233.37",
    stroke: "#78708F",
    strokeWidth: 0.4,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.3687 256.996C82.1361 256.881 81.4243 256.657 81.2372 255.533",
    stroke: "#78708F",
    strokeWidth: 0.4,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.8274 233.611C81.614 233.643 81.0593 233.883 80.5472 234.582",
    stroke: "#78708F",
    strokeWidth: 0.4,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.9077 252.71C66.9193 252.494 67.104 251.919 67.7503 251.342",
    stroke: "#78708F",
    strokeWidth: 0.4,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.9176 230.301C66.9276 230.516 67.1081 231.093 67.7502 231.675",
    stroke: "#78708F",
    strokeWidth: 0.4,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.3731 254.43C79.445 254.43 85.1779 248.697 85.1779 241.625C85.1779 234.553 79.445 228.82 72.3731 228.82C65.3011 228.82 59.5682 234.553 59.5682 241.625C59.5682 248.697 65.3011 254.43 72.3731 254.43Z",
    fill: "url(#paint9_radial_3141_12046)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.504 225.836C232.001 221.913 238.379 221.61 241.009 221.847V225.883C234.072 226.338 230.308 227.973 228.758 229.348L228.578 227.609L228.547 226.746L228.504 225.836Z",
    fill: "#1A1A1A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.373 252.537C78.3992 252.537 83.2844 247.651 83.2844 241.625C83.2844 235.599 78.3992 230.714 72.373 230.714C66.3469 230.714 61.4617 235.599 61.4617 241.625C61.4617 247.651 66.3469 252.537 72.373 252.537Z",
    fill: "#CABDFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.765 231.091C251.765 231.091 256.855 206.711 244.895 191.971C232.935 177.231 222.275 175.241 209.135 175.331C209.135 175.331 184.647 174.216 175.047 199.676L177.475 196.351C177.475 196.351 177.945 195.501 179.545 193.671C182.965 189.741 189.545 181.081 205.465 180.201C210.465 179.921 216.615 179.641 228.195 187.821C237.955 195.801 241.885 207.471 240.825 227.021L251.755 231.081L251.765 231.091Z",
    fill: "#9790AA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.765 231.091C251.765 231.091 256.855 206.711 244.895 191.971C232.935 177.231 222.275 175.241 209.135 175.331C209.135 175.331 184.647 174.216 175.047 199.676L177.475 196.351C177.475 196.351 177.945 195.501 179.545 193.671C182.965 189.741 189.545 181.081 205.465 180.201C210.465 179.921 216.615 179.641 228.195 187.821C237.955 195.801 241.885 207.471 240.825 227.021L251.755 231.081L251.765 231.091Z",
    fill: "url(#paint10_linear_3141_12046)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.765 231.091L240.835 227.031C241.895 207.481 237.955 195.811 228.205 187.831C222.445 183.751 218.025 181.781 214.415 180.861C221.674 181.173 227.494 182.496 232.8 186.128C245.176 193.505 250.721 202.852 252.665 214.081C253.365 223.421 251.765 231.091 251.765 231.091Z",
    fill: "#9790AA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.835 227.031L251.765 231.091C251.765 231.091 252.26 225.417 252.53 223.234C248.977 220.448 243.437 220.367 241.142 220.07C241.116 221.301 240.905 225.731 240.835 227.031Z",
    fill: "url(#paint11_linear_3141_12046)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.43 194.61C241.104 205.569 241.375 219.554 240.867 225.738L243.153 225.834C243.343 215.162 241.606 206.383 240.338 203.44C237.763 197.465 235.637 191.942 228.459 186.479C222.716 182.108 215.731 180.937 214.659 180.937C227.212 184.937 231.635 190.926 234.43 194.61Z",
    fill: "#78708F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.885 261.021C230.06 261.021 222.095 253.056 222.095 243.231C222.095 233.406 230.06 225.441 239.885 225.441C249.71 225.441 257.675 233.406 257.675 243.231C257.675 253.056 249.71 261.021 239.885 261.021Z",
    fill: "#9790AA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.059 227.242C232.536 227.315 234.029 227.674 234.593 229.639",
    stroke: "#78708F",
    strokeWidth: 0.4,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.507 234.361C225.025 234.361 226.413 234.52 227.367 236.537",
    stroke: "#78708F",
    strokeWidth: 0.4,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.533 260.088C234.843 259.923 235.823 259.575 235.967 257.862",
    stroke: "#78708F",
    strokeWidth: 0.4,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.459 235.52C234.705 235.572 235.346 235.952 235.938 237.063",
    stroke: "#78708F",
    strokeWidth: 0.4,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.813 255.099C249.786 254.848 249.469 254.174 248.422 253.477",
    stroke: "#78708F",
    strokeWidth: 0.4,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.806 233.325C249.78 233.575 249.469 234.252 248.426 234.956",
    stroke: "#78708F",
    strokeWidth: 0.4,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.038 227.826C231.421 227.711 232.734 227.936 233.193 229.239",
    stroke: "#78708F",
    strokeWidth: 0.4,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.131 235.062C224.388 235.096 225.194 235.062 225.675 236.079",
    stroke: "#78708F",
    strokeWidth: 0.4,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.517 259.706C233.75 259.59 234.462 259.367 234.649 258.243",
    stroke: "#78708F",
    strokeWidth: 0.4,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.059 236.32C234.272 236.353 234.827 236.592 235.339 237.291",
    stroke: "#78708F",
    strokeWidth: 0.4,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.978 255.419C248.967 255.204 248.782 254.629 248.136 254.051",
    stroke: "#78708F",
    strokeWidth: 0.4,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.969 233.01C248.959 233.226 248.778 233.803 248.136 234.385",
    stroke: "#78708F",
    strokeWidth: 0.4,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.513 257.14C236.441 257.14 230.708 251.407 230.708 244.335C230.708 237.263 236.441 231.53 243.513 231.53C250.585 231.53 256.318 237.263 256.318 244.335C256.318 251.407 250.585 257.14 243.513 257.14Z",
    fill: "url(#paint12_radial_3141_12046)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.513 255.246C237.487 255.246 232.602 250.361 232.602 244.335C232.602 238.309 237.487 233.423 243.513 233.423C249.539 233.423 254.424 238.309 254.424 244.335C254.424 250.361 249.539 255.246 243.513 255.246Z",
    fill: "#CABDFF"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_f_3141_12046)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M195.073 370.382C201.723 352.962 206.399 327.953 209.139 318.323L222.564 322.532C231.084 327.238 240.813 339.621 240.694 355.076C240.575 370.531 227.121 388.958 217.512 404.412L179.766 442.603L163.466 428.823L195.073 370.382Z",
    fill: "#7557B7"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M182.446 446.432C182.446 446.432 266.738 398.345 257.783 306.615C257.783 306.185 257.673 305.765 257.603 305.355C254.593 286.315 219.416 275.632 211.776 302.452C209.036 312.082 204.516 355.302 197.866 372.722L166.146 432.662L182.446 446.442V446.432Z",
    fill: "#9475D7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.446 446.432C182.446 446.432 266.738 398.345 257.783 306.615C257.783 306.185 257.673 305.765 257.603 305.355C254.593 286.315 219.416 275.632 211.776 302.452C209.036 312.082 204.516 355.302 197.866 372.722L166.146 432.662L182.446 446.442V446.432Z",
    fill: "url(#paint13_linear_3141_12046)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.763 301.819C209.906 308.346 207.231 330.301 203.63 349.197C201.918 358.182 199.996 366.476 197.853 372.089L166.133 432.029M182.433 445.809V445.799C182.433 445.799 260.004 401.992 258.554 315.462C258.554 315.032 258.071 310.036 258.001 309.626C257.332 305.395 254.882 297.553 250.606 293.025C243.13 286.412 231.644 282.011 222.315 287.447",
    stroke: "#111111",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.7017 276.585C93.5818 277.906 97.5204 280.597 106.234 280.803",
    stroke: "#111111",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.522 464.256L167.403 464.374C165.46 466.382 162.257 466.443 160.249 464.5C158.254 462.576 158.188 459.403 160.086 457.394C158.139 459.367 154.967 459.41 152.972 457.486C150.964 455.543 150.903 452.339 152.846 450.331L153.603 449.553C151.76 450.982 149.113 450.713 147.603 448.918L146.706 447.85C145.157 446.001 145.392 443.246 147.241 441.697L155.412 434.822C155.92 433.937 156.522 433.089 157.261 432.325C162.022 427.39 169.884 427.251 174.818 432.012L185.451 442.274C190.386 447.036 190.526 454.898 185.764 459.832C184.806 460.82 183.714 461.614 182.562 462.219L176.094 468.924C174.151 470.932 170.948 470.993 168.94 469.05C167.613 467.769 167.15 465.935 167.539 464.265L167.522 464.256Z",
    fill: "#CB6C66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.603 448.918L146.706 447.85C145.157 446.001 145.392 443.246 147.241 441.697L155.412 434.822C155.92 433.937 156.522 433.089 157.261 432.325C162.022 427.39 169.884 427.251 174.818 432.012L185.451 442.274",
    stroke: "#18161B",
    strokeLinecap: "round"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_f_3141_12046)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M87.3019 329.134C85.5519 340.334 80.8397 348.393 72.4997 356.053C64.1597 363.713 68.5662 374.995 68.5662 374.995C71.5462 403.275 99.5362 406.245 99.5362 406.245V421.794C99.5362 421.794 40.7379 429.953 24.3383 384.986C10.2883 326.946 58.1961 301.969 75.2661 293.639C79.7861 291.429 85.9176 294.297 86.9176 299.227C87.3376 301.287 87.4319 304.908 87.3019 308.258C86.9419 317.428 88.6119 320.734 87.3019 329.134Z",
    fill: "#391C74",
    fillOpacity: 0.39
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M87.286 317.495C85.536 328.695 79.606 338.665 71.266 346.325C62.926 353.985 64.566 367.995 64.566 367.995C67.546 396.275 95.536 399.245 95.536 399.245V425.855C95.536 425.855 34.786 447.755 17.856 377.885C3.806 319.845 60.986 287.175 78.056 278.845C82.576 276.635 88.7075 279.502 89.7075 284.432C90.1275 286.492 90.2218 290.113 90.0918 293.463C89.7318 302.633 88.596 309.095 87.286 317.495Z",
    fill: "#6D34E5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M87.286 317.495C85.536 328.695 79.606 338.665 71.266 346.325C62.926 353.985 64.566 367.995 64.566 367.995C67.546 396.275 95.536 399.245 95.536 399.245V425.855C95.536 425.855 34.786 447.755 17.856 377.885C3.806 319.845 60.986 287.175 78.056 278.845C82.576 276.635 88.7075 279.502 89.7075 284.432C90.1275 286.492 90.2218 290.113 90.0918 293.463C89.7318 302.633 88.596 309.095 87.286 317.495Z",
    fill: "url(#paint14_linear_3141_12046)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M82.9697 278.902C76.9807 277.697 63.0103 284.333 41.2551 304.539",
    stroke: "#111111",
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.856 377.885C34.786 447.755 95.536 425.855 95.536 425.855V399.245C95.536 399.245 67.546 396.275 64.566 367.995C64.566 367.995 63.675 353.846 71.266 346.325C81.1949 336.487 85.536 328.695 87.286 317.495C88.596 309.095 89.7318 302.633 90.0918 293.463C90.2218 290.113 90.1275 286.492 89.7075 284.432",
    stroke: "#111111",
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M149.442 368.331L157.462 425.371L112.862 425.131L104.842 368.091L149.442 368.331Z",
    fill: "#C2BECF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M149.442 368.331L157.462 425.371L112.862 425.131L104.842 368.091L149.442 368.331Z",
    fill: "url(#paint15_linear_3141_12046)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M149.442 368.331L150.412 362.931L158.432 419.981L157.462 425.371L149.442 368.331Z",
    fill: "#806FBB"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M149.442 368.331L150.412 362.931L158.432 419.981L157.462 425.371L149.442 368.331Z",
    fill: "url(#paint16_linear_3141_12046)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M104.842 368.091L105.812 362.691L150.412 362.931L149.442 368.331L104.842 368.091Z",
    fill: "#CAC3E1"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M104.842 368.091L105.812 362.691L150.412 362.931L149.442 368.331L104.842 368.091Z",
    fill: "url(#paint17_linear_3141_12046)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M117.642 414.491L117.802 414.441C120.482 413.651 122.022 410.841 121.232 408.161C120.452 405.501 117.672 403.971 115.012 404.721C117.662 403.911 119.172 401.121 118.392 398.461C117.602 395.781 114.792 394.241 112.112 395.031L111.072 395.341C113.192 394.371 114.182 391.901 113.292 389.731L112.762 388.441C111.842 386.211 109.292 385.141 107.062 386.061L97.1823 390.111C96.1623 390.151 95.1323 390.291 94.1123 390.591C87.5323 392.521 83.7623 399.421 85.6923 406.001L89.8523 420.181C91.7823 426.761 98.6823 430.531 105.262 428.601C106.582 428.211 107.792 427.611 108.862 426.871L117.802 424.251C120.482 423.461 122.022 420.651 121.232 417.971C120.712 416.201 119.302 414.941 117.642 414.511V414.491Z",
    fill: "#CB6C66"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M113.292 389.731L112.762 388.441C111.842 386.211 109.292 385.141 107.062 386.061L97.1823 390.111C96.1623 390.151 95.1323 390.291 94.1123 390.591C87.5323 392.521 83.7623 399.421 85.6923 406.001L89.8523 420.181",
    stroke: "#18161B",
    strokeLinecap: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M99.3897 394.87C101.999 400.376 107.437 413.356 108.32 421.23",
    stroke: "#18161B",
    strokeLinecap: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M108.38 395.658C112.484 394.716 113.02 392.016 113.583 390.79C113.823 391.344 113.824 392.804 112.707 394.278C111.45 395.935 109.835 395.71 108.38 395.658Z",
    fill: "#A3504B"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M114.292 404.905C117.512 403.194 118.042 400.605 118.605 399.378C118.659 399.964 118.838 401.495 117.721 402.969C116.464 404.625 114.998 405 114.292 404.905Z",
    fill: "#A3504B"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M117.128 414.452C120.347 412.742 120.878 410.152 121.44 408.926C121.495 409.512 121.674 411.043 120.556 412.516C119.299 414.173 117.834 414.547 117.128 414.452Z",
    fill: "#A3504B"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_3141_12046",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 122,
    y: 382,
    width: 13,
    height: 10
  }, _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M134.962 382.367H122.962V391.367H134.962V382.367Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_3141_12046)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M128.962 382.367C125.646 382.367 122.962 384.381 122.962 386.867C122.962 389.353 125.646 391.367 128.962 391.367C132.278 391.367 134.962 389.353 134.962 386.867C134.962 384.381 132.278 382.367 128.962 382.367Z",
    fill: "#817796"
  }))), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M128.962 381.321C129.317 380.187 130.308 379.217 131.962 379.386C131.651 380.092 130.574 381.655 128.962 381.321Z",
    fill: "#817796"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_d_3141_12046)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 118.47,
    y: 6,
    width: 163,
    height: 36,
    rx: 8,
    fill: "#F1EEFF",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.228 19.5156V28H136.868L132.849 22.1992H132.778V28H131.255V19.5156H132.638L136.634 25.3164H136.716V19.5156H138.228ZM142.552 28.1289C140.636 28.1289 139.458 26.8516 139.458 24.8594C139.458 22.8906 140.653 21.5547 142.47 21.5547C144.028 21.5547 145.376 22.5332 145.376 24.7656V25.2344H140.935C140.958 26.3184 141.597 26.9629 142.563 26.957C143.22 26.9629 143.659 26.6816 143.853 26.3008H145.317C145.048 27.4023 144.028 28.1289 142.552 28.1289ZM140.94 24.2148H143.946C143.94 23.3477 143.354 22.7148 142.493 22.7148C141.597 22.7148 140.993 23.4062 140.94 24.2148ZM147.825 28L146.021 21.6367H147.544L148.669 26.1133H148.728L149.864 21.6367H151.376L152.524 26.0898H152.583L153.696 21.6367H155.22L153.415 28H151.856L150.661 23.6875H150.579L149.384 28H147.825ZM158.923 19.5156H160.435V25.4805C160.435 27.1211 159.339 28.1172 157.704 28.1172C156.216 28.1172 155.073 27.3086 155.079 25.75H156.603C156.608 26.4414 157.077 26.8574 157.763 26.8633C158.501 26.8574 158.917 26.3828 158.923 25.4805V19.5156ZM164.759 28.1289C162.843 28.1289 161.665 26.8516 161.665 24.8594C161.665 22.8906 162.86 21.5547 164.677 21.5547C166.235 21.5547 167.583 22.5332 167.583 24.7656V25.2344H163.142C163.165 26.3184 163.804 26.9629 164.771 26.957C165.427 26.9629 165.866 26.6816 166.06 26.3008H167.524C167.255 27.4023 166.235 28.1289 164.759 28.1289ZM163.147 24.2148H166.153C166.147 23.3477 165.562 22.7148 164.7 22.7148C163.804 22.7148 163.2 23.4062 163.147 24.2148ZM168.45 26.207C168.45 24.7773 169.64 24.3613 170.817 24.2852C171.263 24.25 172.171 24.209 172.452 24.1973L172.446 23.6875C172.446 23.0547 172.042 22.6914 171.298 22.6914C170.63 22.6914 170.22 22.9961 170.103 23.4531H168.661C168.767 22.3691 169.739 21.5547 171.333 21.5547C172.54 21.5547 173.935 22.0527 173.935 23.7461V28H172.505V27.1211H172.458C172.177 27.6602 171.585 28.1289 170.583 28.1289C169.37 28.1289 168.45 27.4668 168.45 26.207ZM169.892 26.1953C169.892 26.7461 170.343 27.0273 170.97 27.0273C171.878 27.0273 172.458 26.4297 172.458 25.7148L172.452 25.1934C172.183 25.2051 171.351 25.2578 171.052 25.2812C170.343 25.3398 169.892 25.6387 169.892 26.1953ZM176.841 24.2734V28H175.341V21.6367H176.771V22.7148H176.853C177.14 22.0059 177.79 21.5547 178.739 21.5547C180.058 21.5547 180.925 22.4219 180.919 23.9453V28H179.431V24.1797C179.431 23.3242 178.968 22.8145 178.188 22.8203C177.397 22.8145 176.841 23.3477 176.841 24.2734ZM185.958 23.4531C185.864 22.9727 185.466 22.6621 184.833 22.668C184.194 22.6621 183.726 22.9844 183.731 23.418C183.726 23.7461 183.989 23.9922 184.634 24.1445L185.712 24.3672C186.913 24.6309 187.499 25.1875 187.505 26.1016C187.499 27.2969 186.45 28.1289 184.786 28.1289C183.169 28.1289 182.214 27.4023 182.056 26.1836H183.579C183.667 26.7285 184.089 26.998 184.786 26.9922C185.507 26.998 185.976 26.7051 185.981 26.2305C185.976 25.8613 185.688 25.627 185.056 25.4922L184.036 25.2695C182.853 25.0293 182.237 24.4082 182.243 23.5C182.237 22.3223 183.257 21.5547 184.81 21.5547C186.327 21.5547 187.265 22.2988 187.376 23.4531H185.958Z",
    fill: "#141414"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.138 28H195.255V19.5156H198.185C200.716 19.5156 202.245 21.1035 202.251 23.7461C202.245 26.4004 200.716 28 198.138 28ZM196.778 26.6758H198.056C199.831 26.6816 200.728 25.7031 200.728 23.7461C200.728 21.8008 199.831 20.834 198.103 20.8398H196.778V26.6758ZM203.528 28V21.6367H205.028V28H203.528ZM203.423 19.9141C203.423 19.4688 203.815 19.1055 204.29 19.1055C204.765 19.1055 205.157 19.4688 205.157 19.9141C205.157 20.3652 204.765 20.7285 204.29 20.7344C203.815 20.7285 203.423 20.3652 203.423 19.9141ZM209.634 21.6367V22.7852H208.38V26.0898C208.38 26.6992 208.685 26.8223 209.06 26.8281C209.235 26.834 209.528 26.8164 209.716 26.8047V28.0234C209.54 28.0527 209.253 28.0879 208.872 28.082C207.747 28.0879 206.88 27.5312 206.892 26.3359V22.7852H205.978V21.6367H206.892V20.1133H208.38V21.6367H209.634ZM213.958 21.6367V22.7852H212.704V26.0898C212.704 26.6992 213.009 26.8223 213.384 26.8281C213.56 26.834 213.853 26.8164 214.04 26.8047V28.0234C213.864 28.0527 213.577 28.0879 213.196 28.082C212.071 28.0879 211.204 27.5312 211.216 26.3359V22.7852H210.302V21.6367H211.216V20.1133H212.704V21.6367H213.958ZM217.813 28.1289C215.956 28.1289 214.767 26.8105 214.767 24.8477C214.767 22.8672 215.956 21.5547 217.813 21.5547C219.677 21.5547 220.866 22.8672 220.86 24.8477C220.866 26.8105 219.677 28.1289 217.813 28.1289ZM216.278 24.8359C216.278 26.002 216.788 26.9336 217.825 26.9336C218.845 26.9336 219.354 26.002 219.349 24.8359C219.354 23.6699 218.845 22.7324 217.825 22.7383C216.788 22.7324 216.278 23.6699 216.278 24.8359Z",
    fill: "#141414"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M247.025 18.0311C244.932 17.8121 243.701 18.773 242.973 20.1437C242.246 18.773 241.015 17.8192 238.922 18.0311C236.828 18.2431 235.493 19.9459 235.47 21.8394C235.418 27.2374 241.405 29.5266 242.718 29.9576C242.883 30.0141 243.056 30.0141 243.221 29.9576C244.534 29.5195 250.529 27.2374 250.469 21.8394C250.447 19.9459 249.014 18.236 247.018 18.0311H247.025Z",
    fill: "#141414"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.021 26.418V25.1992L258.688 19.5156H260.587V25.1641H261.7V26.418H260.587V28H259.134V26.418H255.021ZM256.579 25.1641H259.157V21.25H259.063L256.579 25.1055V25.1641ZM262.931 28V19.5156H264.431V24.1914H264.536L266.821 21.6367H268.567L266.101 24.3789L268.72 28H266.938L264.981 25.2695L264.431 25.8555V28H262.931Z",
    fill: "#141414"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_d_3141_12046)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 167.656,
    y: 124.531,
    width: 131,
    height: 36,
    rx: 8,
    fill: "#F1EEFF",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.648 137.66V139.219H183.394V137.66H184.601V142.711H180.418V137.66H181.648ZM181.648 141.679H183.394V140.226H181.648V141.679ZM181.812 144.949V143.894H189.066V147.574H187.765V144.949H181.812ZM185.551 143.297V137.191H186.769V139.629H187.824V136.992H189.066V143.355H187.824V140.695H186.769V143.297H185.551ZM199.519 136.98V147.574H198.265V136.98H199.519ZM190.484 141.562C190.484 139.23 191.386 137.783 192.769 137.789C193.666 137.783 194.363 138.375 194.756 139.406H196.144V137.168H197.375V147.058H196.144V143.719H194.756C194.369 144.756 193.666 145.353 192.769 145.347C191.386 145.353 190.484 143.9 190.484 141.562ZM191.679 141.562C191.668 143.22 192.072 144.111 192.769 144.105C193.472 144.111 193.906 143.22 193.906 141.562C193.906 139.91 193.472 139.013 192.769 139.019C192.072 139.013 191.668 139.91 191.679 141.562ZM195.019 140.461C195.072 140.801 195.101 141.17 195.101 141.562C195.101 141.949 195.072 142.312 195.025 142.652H196.144V140.461H195.019ZM209.551 136.992V144.785H208.261V136.992H209.551ZM201.289 138.75V137.707H206.176V140.976H202.59V142.312C204.506 142.312 205.771 142.254 207.23 141.984L207.371 143.027C205.771 143.326 204.383 143.379 202.215 143.379H201.312V139.992H204.886V138.75H201.289ZM202.496 147.363V144.152H203.808V146.308H209.844V147.363H202.496Z",
    fill: "#141414"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.804 138.855C221.793 140.244 222.672 141.574 224.336 142.113L223.656 143.144C222.484 142.746 221.646 141.949 221.183 140.929C220.715 142.054 219.842 142.933 218.605 143.367L217.879 142.336C219.619 141.767 220.492 140.349 220.492 138.844V137.636H221.804V138.855ZM219.578 147.363V144H220.914V146.308H226.785V147.363H219.578ZM225.062 144.761V136.98H226.363V140.109H227.84V141.211H226.363V144.761H225.062ZM231.648 139.359C231.648 140.478 232.328 141.586 233.664 142.043L233.078 143.027C232.105 142.67 231.437 142.002 231.056 141.187C230.687 142.078 230.013 142.81 229.011 143.203L228.402 142.242C229.744 141.715 230.406 140.56 230.418 139.359V139.277H228.672V138.258H230.418V137.097H231.648V138.258H233.371V139.277H231.648V139.359ZM230.183 145.008V143.953H237.437V147.574H236.136V145.008H230.183ZM233.945 143.426V137.168H235.176V139.711H236.195V136.992H237.437V143.472H236.195V140.765H235.176V143.426H233.945Z",
    fill: "#141414"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M264.212 136.562C262.118 136.343 260.888 137.304 260.16 138.675C259.432 137.304 258.201 136.35 256.108 136.562C254.014 136.774 252.679 138.477 252.656 140.37C252.604 145.768 258.592 148.058 259.905 148.489C260.07 148.545 260.242 148.545 260.407 148.489C261.72 148.051 267.716 145.768 267.656 140.37C267.633 138.477 266.2 136.767 264.204 136.562H264.212Z",
    fill: "#141414"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.535 146.648C273.877 146.636 272.224 145.652 272.23 142.523C272.23 139.623 273.549 137.929 275.629 137.929C277.263 137.929 278.388 138.955 278.582 140.332H277.07C276.918 139.681 276.402 139.248 275.629 139.254C274.398 139.248 273.713 140.338 273.707 142.125H273.789C274.222 141.392 275.037 140.959 275.969 140.965C277.492 140.959 278.67 142.113 278.664 143.719C278.67 145.406 277.41 146.66 275.535 146.648ZM273.871 143.765C273.883 144.65 274.574 145.412 275.535 145.418C276.478 145.412 277.181 144.685 277.187 143.754C277.181 142.851 276.502 142.125 275.558 142.125C274.603 142.125 273.883 142.881 273.871 143.765ZM279.965 146.531V138.047H281.465V142.722H281.57L283.855 140.168H285.601L283.135 142.91L285.754 146.531H283.972L282.015 143.801L281.465 144.386V146.531H279.965Z",
    fill: "#141414"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter6_d_3141_12046)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 8.46973,
    y: 63,
    width: 149,
    height: 42,
    rx: 8,
    fill: "#F1EEFF",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.1631 79.1016V89H23.3857V79.1016H25.1631ZM33.2568 79.1016H35.0479V85.5684C35.041 87.6943 33.4414 89.1504 31.0283 89.1504C28.6016 89.1504 27.0156 87.6943 27.0088 85.5684V79.1016H28.7861V85.418C28.793 86.6689 29.6611 87.5576 31.0283 87.5645C32.3955 87.5576 33.2568 86.6689 33.2568 85.418V79.1016Z",
    fill: "#141414"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.6279 85.541V90.0664H44.6436V85.541H52.6279ZM43.3037 84.2969V78.5H44.8076V80.168H47.6924V78.5H49.1963V84.2969H43.3037ZM44.8076 83.0664H47.6924V81.3574H44.8076V83.0664ZM46.1475 88.8359H51.124V86.7578H46.1475V88.8359ZM51.1104 84.9395V77.8574H52.6279V80.6738H54.3506V81.9453H52.6279V84.9395H51.1104ZM65.3291 77.8574V86.9902H63.8115V83.7637H62.0615V82.5059H63.8115V81.3301H62.0615V80.0996H63.8115V77.8574H65.3291ZM54.9932 84.1055C55.4238 84.1055 55.8955 84.1055 56.3877 84.0986V80.0039H55.3076V78.7871H61.8838V80.0039H60.79V83.9551C61.2549 83.9209 61.7061 83.8799 62.1436 83.832L62.2119 84.9395C59.8672 85.3154 57.126 85.3633 55.1572 85.3633L54.9932 84.1055ZM57.208 89.9707V86.2793H58.7393V88.7402H65.6436V89.9707H57.208ZM57.8643 84.0781C58.3428 84.0713 58.835 84.0508 59.3271 84.0303V80.0039H57.8643V84.0781ZM71.7412 81.3711C71.7412 83.3945 72.9307 85.5273 74.9268 86.3613L74.0928 87.5645C72.6299 86.9287 71.5635 85.6367 70.9961 84.0645C70.4287 85.7598 69.3418 87.1816 67.8994 87.8652L67.0244 86.6758C68.9727 85.7734 70.1895 83.4697 70.1963 81.3711V80.332H67.4756V79.0742H74.4482V80.332H71.7412V81.3711ZM75.8291 90.2168V77.8574H77.3604V90.2168H75.8291Z",
    fill: "#141414"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M106.566 77.0363C104.193 76.7808 102.799 77.9018 101.974 79.501C101.149 77.9018 99.7544 76.789 97.3819 77.0363C95.0093 77.2836 93.4956 79.2702 93.4701 81.4793C93.4106 87.777 100.197 90.4477 101.685 90.9505C101.872 91.0165 102.067 91.0165 102.255 90.9505C103.743 90.4395 110.537 87.777 110.469 81.4793C110.444 79.2702 108.819 77.2754 106.557 77.0363H106.566Z",
    fill: "#141414"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.29 89V87.7148L118.79 84.3379C119.788 83.3398 120.308 82.752 120.308 81.918C120.308 80.9951 119.576 80.4141 118.612 80.4141C117.594 80.4141 116.938 81.0498 116.944 82.0547H115.249C115.242 80.1816 116.65 78.9648 118.626 78.9648C120.649 78.9648 122.01 80.1748 122.017 81.8359C122.01 82.9502 121.477 83.8525 119.528 85.6914L117.765 87.4414V87.5098H122.167V89H115.29ZM124.819 89.1094C124.231 89.1094 123.746 88.6309 123.753 88.043C123.746 87.4688 124.231 86.9971 124.819 86.9902C125.387 86.9971 125.872 87.4688 125.872 88.043C125.872 88.6309 125.387 89.1094 124.819 89.1094ZM130.931 89.1367C128.955 89.1367 127.499 87.9541 127.444 86.3203H129.181C129.235 87.1201 129.994 87.6943 130.931 87.7012C132.038 87.6943 132.838 86.8945 132.831 85.8008C132.838 84.666 132.018 83.8662 130.876 83.8594C130.104 83.8525 129.543 84.126 129.235 84.707H127.581L128.183 79.1016H134.034V80.5918H129.646L129.345 83.2168H129.44C129.823 82.7861 130.541 82.4717 131.354 82.4648C133.193 82.4717 134.561 83.8389 134.554 85.7461C134.561 87.7217 133.07 89.1367 130.931 89.1367ZM136.071 89V79.1016H137.821V84.5566H137.944L140.61 81.5762H142.647L139.77 84.7754L142.825 89H140.747L138.464 85.8145L137.821 86.498V89H136.071Z",
    fill: "#141414"
  }))), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M68.3583 246.205L66.6797 242.48L67.7883 241.981L69.4669 245.706C69.6047 246.012 69.4682 246.372 69.1621 246.509C68.856 246.647 68.4961 246.511 68.3583 246.205Z",
    fill: "#B9A9FD"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M73.6102 243.841L71.9316 240.117L73.0401 239.618L74.7187 243.342C74.8565 243.648 74.72 244.008 74.4139 244.146C74.1078 244.283 73.7479 244.147 73.6102 243.841Z",
    fill: "#B9A9FD"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M72.4387 245.045C72.7731 244.894 72.9222 244.501 72.7717 244.167C72.6212 243.832 72.2281 243.683 71.8937 243.834C71.5593 243.984 71.4102 244.377 71.5607 244.712C71.7112 245.046 72.1043 245.195 72.4387 245.045Z",
    fill: "#B9A9FD"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M67.5596 238.501C68.7862 237.954 70.223 238.507 70.7733 239.737L70.7735 239.738L71.1339 240.529C71.6831 241.761 71.135 243.2 69.9075 243.748C68.6799 244.295 67.2428 243.741 66.6929 242.51L67.8032 242.014C68.0767 242.627 68.7999 242.906 69.4104 242.633C70.0271 242.358 70.2972 241.637 70.0236 241.024L69.6639 240.234C69.3903 239.622 68.6672 239.343 68.0566 239.616C67.5177 239.856 67.2392 240.449 67.3695 241.006L66.2503 241.509C65.8476 240.329 66.4018 239.018 67.5596 238.501Z",
    fill: "#B9A9FD"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M72.8113 236.137C74.0379 235.59 75.4748 236.143 76.025 237.373L76.0253 237.374L76.3856 238.165C76.9348 239.397 76.3867 240.836 75.1592 241.384C73.9317 241.931 72.4945 241.377 71.9447 240.146L73.0549 239.65C73.3284 240.263 74.0516 240.542 74.6621 240.269C75.2788 239.994 75.5489 239.273 75.2753 238.66L74.9156 237.871C74.642 237.258 73.9189 236.979 73.3083 237.252C72.7694 237.492 72.491 238.085 72.6212 238.642L71.502 239.145C71.0993 237.965 71.6535 236.654 72.8113 236.137Z",
    fill: "#B9A9FD"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M238.534 245.836L240.122 242.072L241.242 242.545L239.654 246.309C239.523 246.618 239.167 246.763 238.858 246.633C238.548 246.502 238.403 246.145 238.534 245.836Z",
    fill: "#B9A9FD"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M243.839 248.077L245.427 244.313L246.547 244.786L244.959 248.55C244.829 248.859 244.472 249.004 244.163 248.874C243.854 248.743 243.709 248.386 243.839 248.077Z",
    fill: "#B9A9FD"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M242.16 248.037C242.498 248.18 242.888 248.022 243.03 247.684C243.173 247.346 243.015 246.957 242.677 246.814C242.339 246.671 241.95 246.83 241.807 247.167C241.664 247.505 241.823 247.895 242.16 248.037Z",
    fill: "#B9A9FD"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M243.636 240.01C244.872 240.536 245.445 241.966 244.917 243.206L244.917 243.207L244.582 244.009C244.053 245.249 242.625 245.827 241.389 245.3C240.153 244.773 239.581 243.343 240.109 242.102L241.227 242.578C240.964 243.196 241.252 243.916 241.867 244.178C242.489 244.442 243.201 244.149 243.464 243.532L243.798 242.731C244.061 242.114 243.773 241.394 243.158 241.132C242.615 240.901 241.991 241.1 241.672 241.574L240.541 241.097C241.133 239.998 242.47 239.513 243.636 240.01Z",
    fill: "#B9A9FD"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M248.942 242.251C250.178 242.777 250.75 244.206 250.222 245.447L250.222 245.448L249.888 246.25C249.359 247.49 247.931 248.068 246.694 247.541C245.458 247.013 244.886 245.583 245.415 244.342L246.533 244.819C246.27 245.437 246.558 246.156 247.173 246.418C247.794 246.683 248.507 246.39 248.769 245.773L249.103 244.972C249.366 244.355 249.079 243.635 248.463 243.373C247.921 243.142 247.297 243.341 246.977 243.815L245.847 243.338C246.438 242.239 247.775 241.754 248.942 242.251Z",
    fill: "#B9A9FD"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter7_f_3141_12046)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M84.7264 235.638C82.1208 229.909 74.9082 227.28 72.6303 227.096L74.6677 226.653L76.3674 226.851C80.9504 227.883 89.0361 232.561 88.9953 239.353C88.9444 247.843 85.1693 249.264 82.7395 251.163C80.7957 252.682 77.3926 253.263 74.6677 252.951C79.9662 251.767 83.0349 248.641 83.907 247.227C85.2658 245.751 87.3319 241.367 84.7264 235.638Z",
    fill: "#CFC6E8"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter8_f_3141_12046)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M230.303 239.136C232.909 233.406 240.121 230.778 242.399 230.594L240.362 230.151L238.662 230.348C234.079 231.381 225.993 236.059 226.034 242.851C226.085 251.341 229.86 252.762 232.29 254.661C234.234 256.18 237.637 256.761 240.362 256.449C235.063 255.264 231.994 252.139 231.122 250.725C229.764 249.249 227.697 244.865 230.303 239.136Z",
    fill: "#CFC6E8"
  }))), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M121.89 195.212C121.838 195.154 121.845 195.064 121.905 195.015L124.044 193.277C124.1 193.231 124.182 193.237 124.231 193.291C124.283 193.349 124.276 193.439 124.216 193.488L122.077 195.227C122.021 195.273 121.938 195.266 121.89 195.212Z",
    fill: "white"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M121.467 195.522C121.419 195.464 121.427 195.378 121.486 195.33L121.599 195.238C121.657 195.191 121.743 195.199 121.79 195.257C121.838 195.315 121.83 195.402 121.771 195.45L121.658 195.541C121.6 195.589 121.514 195.58 121.467 195.522Z",
    fill: "white"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M224.748 277.133C223.123 278.672 217.063 280.642 212.101 280.787",
    stroke: "black",
    strokeLinecap: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_3141_12046",
    x: 140.786,
    y: 197.687,
    width: 12.3519,
    height: 24.7037,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "effect1_foregroundBlur_3141_12046"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_3141_12046",
    x: 164.278,
    y: 197.687,
    width: 12.3519,
    height: 24.7037,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "effect1_foregroundBlur_3141_12046"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_3141_12046",
    x: 159.466,
    y: 314.323,
    width: 85.2285,
    height: 132.28,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "effect1_foregroundBlur_3141_12046"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_f_3141_12046",
    x: 17.7925,
    y: 288.883,
    width: 85.7437,
    height: 137.49,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "effect1_foregroundBlur_3141_12046"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_d_3141_12046",
    x: 104.47,
    y: 0,
    width: 183,
    height: 56,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -4,
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3141_12046"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3141_12046",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_d_3141_12046",
    x: 153.656,
    y: 118.531,
    width: 151,
    height: 56,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -4,
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3141_12046"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3141_12046",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_d_3141_12046",
    x: 0.469727,
    y: 59,
    width: 165,
    height: 58,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3141_12046"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3141_12046",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter7_f_3141_12046",
    x: 68.6303,
    y: 222.653,
    width: 24.3652,
    height: 34.3798,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "effect1_foregroundBlur_3141_12046"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter8_f_3141_12046",
    x: 222.034,
    y: 226.151,
    width: 24.3652,
    height: 34.3798,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "effect1_foregroundBlur_3141_12046"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3141_12046",
    x1: 163.695,
    y1: 243.615,
    x2: 169.006,
    y2: 306.609,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6D34E5",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#381C74"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3141_12046",
    x1: 283.401,
    y1: 305.443,
    x2: 217.462,
    y2: 334.211,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7749DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9273D4",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3141_12046",
    x1: 91.7233,
    y1: 252.49,
    x2: 91.0855,
    y2: 264.152,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423E52",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_3141_12046",
    x1: 111.582,
    y1: 200.557,
    x2: 120.479,
    y2: 221.245,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#272727",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_3141_12046",
    x1: 218.183,
    y1: 241.276,
    x2: 212.44,
    y2: 270.082,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_3141_12046",
    x1: 226.259,
    y1: 184.771,
    x2: 213.192,
    y2: 215.882,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#272727",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_3141_12046",
    x1: 83.2147,
    y1: 184.089,
    x2: 94.7702,
    y2: 197.392,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6053AF",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F1F0FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_3141_12046",
    x1: 128.422,
    y1: 176.524,
    x2: 116.202,
    y2: 199.249,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6F6295"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9790AA",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_3141_12046",
    x1: 68.6809,
    y1: 218.468,
    x2: 69.999,
    y2: 224.953,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#887DA6",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#887DA6"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint9_radial_3141_12046",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(72.3731 241.947) rotate(86.2422) scale(13.2982)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.543009,
    stopColor: "#5F5971"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9790AA",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_3141_12046",
    x1: 187.464,
    y1: 179.233,
    x2: 199.684,
    y2: 201.958,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6F6295"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9790AA",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_3141_12046",
    x1: 247.205,
    y1: 221.177,
    x2: 245.887,
    y2: 227.662,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#887DA6",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#887DA6"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint12_radial_3141_12046",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(243.513 244.656) rotate(93.7578) scale(13.2982)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.543009,
    stopColor: "#5F5971"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9790AA",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_3141_12046",
    x1: 218.552,
    y1: 424.771,
    x2: 181.847,
    y2: 409.911,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7655BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9576D8",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_3141_12046",
    x1: 15.656,
    y1: 327.114,
    x2: 66.9471,
    y2: 335.946,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#422187"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6D34E5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_3141_12046",
    x1: 126.896,
    y1: 368.091,
    x2: 131.152,
    y2: 416.279,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ADA3CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C2BECF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_3141_12046",
    x1: 149.993,
    y1: 364.828,
    x2: 157.91,
    y2: 423.901,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#806FBB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#806FBB",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_3141_12046",
    x1: 127.627,
    y1: 362.691,
    x2: 127.627,
    y2: 368.331,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CAC3E1",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B1A6D6"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg09IntroOnboard02);
export default __webpack_public_path__ + "static/media/09_intro_onboard_02.8fa5d00c630f2da2d7a4204e3a9dc332.svg";
export { ForwardRef as ReactComponent };